export default __webpack_public_path__ + "static/media/Download_on_the_App_Store_Badge_AR_RGB_blk_102417.d7906eb1.svg";